exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-color:#d3d3d3}.main-container{display:flex;flex-direction:column-reverse;height:90vh}.attachments-item{position:relative;padding:10px}.remove-attachment{position:absolute;top:16px;right:16px}.attachments-item .remove-attachment:hover{cursor:pointer;background-color:#448aff;color:#fff}.attachments-item .att-image{min-width:100%}.controls{display:flex;flex-direction:column;background-color:#d3d3d3}.image-container{overflow-y:auto}.expired{top:50%;width:100%;text-align:center;position:absolute;text-transform:uppercase;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/supportNew/fileUpload.vue
// module id = 427
// module chunks = 0